"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartShippingMethodSelected = void 0;
const enums_1 = require("../../enums");
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
function shippingMethodLabel(shippingMethod) {
    switch (shippingMethod) {
        case 'online':
            return 'PDF';
        case 'express':
            return 'Express';
        case 'standard':
            return 'Standard';
        case 'box_standard':
            return 'Standard';
        case 'box_express':
            return 'Express';
        default:
            return null;
    }
}
function trackCartShippingMethodSelected(shippingMethod) {
    const eventLabel = shippingMethodLabel(shippingMethod);
    if (eventLabel) {
        (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
            eventCategory: enums_1.EventCategory.Cart,
            eventAction: enums_1.CartEventType.SelectShippingMethod,
            eventLabel,
            eventData: {
                eventName: enums_1.GA4EventName.selectShippingMethod,
                feature_category: enums_1.GA4FeatureCategory.Cart,
                shipping_method: eventLabel,
            },
        });
    }
}
exports.trackCartShippingMethodSelected = trackCartShippingMethodSelected;
//# sourceMappingURL=trackCartShippingMethodSelected.js.map